import { IOption } from './_types';

export const options: IOption[] = [
  {
    name: 'model',
    value: 'model',
    selectionType: 'listOption',
    title: 'Model options',
    lang: {
      en: 'model',
      es: 'modelo',
    },
    data: [
      {
        image: './images/modelStrong.png',
        name: 'Standard',
        value: 'standard',
      },
      {
        image: './images/modelPanoramic.png',
        name: 'Panorama',
        value: 'panorama',
      },
      {
        image: './images/modelPanoramic.png',
        name: 'Top Professional',
        value: 'topProfessional',
      },
      {
        image: './images/modelStrong.png',
        name: 'Individual',
        value: 'individual',
      },
      // {
      //   image: './images/modelPanoramic.png',
      //   name: 'Gustavo Pratto Court',
      //   value: 'panorama2',
      // },
    ],
  },
  {
    name: 'grass type',
    value: 'grassType',
    selectionType: 'imageOption-3',
    title: 'Grass type options',
    lang: {
      en: 'Grass type',
      es: 'Tipo de césped',
    },
    data: [
      {
        image: './images/fibered.webp',
        name: 'Fibered',
        value: 'fibered',
        lang: {
          en: 'Fibered',
          es: 'Fibrilado',
        },
      },
      {
        image: './images/monofilament.webp',
        name: 'Monofilament',
        value: 'monofilament',
        lang: {
          en: 'Monofilament',
          es: 'Monofilamento',
        },
      },
      {
        image: './images/texturized.webp',
        name: 'Texturized',
        value: 'texturized',
        lang: {
          en: 'Texturized',
          es: 'Texturizado',
        },
      },
    ],
  },
  {
    name: 'grass color',
    value: 'grassColor',
    selectionType: 'colorOption',
    title: 'Grass color',
    lang: {
      en: 'Grass color',
      es: 'Color de césped',
    },
    data: [
      {
        name: 'Blue',
        image: './images/blueGrass.png',
        value: '#3366ff',
        lang: {
          en: 'Blue',
          es: 'Azul',
        },
      },
      {
        name: 'Green',
        image: './images/greenGrass.png',
        value: '#46ce57',
        lang: {
          en: 'Green',
          es: 'Verde',
        },
      },
      {
        name: 'Orange',
        image: './images/orangeGrass.png',
        value: 'orange',
        lang: {
          en: 'Orange',
          es: 'Naranja',
        },
      },
      {
        name: 'Purple',
        image: './images/purpleGrass.png',
        value: 'purple',
        lang: {
          en: 'Purple',
          es: 'Morado',
        },
      },
      {
        name: 'Black',
        image: './images/blackGrass.png',
        value: 'black',
        lang: {
          en: 'Black',
          es: 'Negro',
        },
      },
      {
        name: 'Pink',
        image: './images/fuchsiaGrass.png',
        value: 'fuchsia',
        lang: {
          en: 'Pink',
          es: 'Rosa',
        },
      },
    ],
  },
  {
    name: 'mesh color',
    value: 'meshColor',
    // selectionType: 'colorValue',
    selectionType: 'colorOption',
    title: 'Mesh color',
    lang: {
      en: 'Mesh color',
      es: 'Color de malla',
    },
    data: [
      {
        name: 'Blue',
        image: './images/blueFrame.png',
        value: '#004f7b',
        lang: {
          en: 'Blue',
          es: 'Azul',
        },
      },
      {
        name: 'Green',
        image: './images/greenFrame.png',
        value: '#134333',
        lang: {
          en: 'Green',
          es: 'Verde',
        },
      },
      {
        name: 'White',
        image: './images/whiteFrame.png',
        value: '#e9e8e0',
      },
      {
        name: 'Black',
        image: './images/blackFrame.png',
        value: '#0e0e0f',
        lang: {
          en: 'Black',
          es: 'Negro',
        },
      },
    ],
  },
  {
    name: 'frame color',
    value: 'frameColor',
    selectionType: 'colorValue',
    title: 'Frame color',
    lang: {
      en: 'Frame color',
      es: 'Color de marco',
    },
    data: [
      {
        name: 'White',
        image: '',
        value: '#FFFFFF',
      },
      {
        name: 'Green',
        image: '',
        value: '#7cd359',
        lang: {
          en: 'Green',
          es: 'Verde',
        },
      },
      {
        name: 'Blue',
        image: '',
        value: '#50c9eb',
        lang: {
          en: 'Blue',
          es: 'Azul',
        },
      },
      {
        name: 'Black',
        image: '',
        value: '#0e0e0f',
        lang: {
          en: 'Black',
          es: 'Negro',
        },
      },
      {
        name: 'Yellow',
        image: '',
        value: '#ddea3e',
      },
      {
        name: 'Red',
        image: '',
        value: '#f06363',
      },
      {
        name: 'Gray',
        image: '',
        value: '#d3d3d3',
      },
    ],
  },

  {
    name: 'Light Post Type',
    value: 'illuminationPillars',
    selectionType: 'imageOption-3',
    title: 'Grass type options',
    lang: {
      en: 'Light Post Type',
      es: 'Tipo de poste de luz',
    },
    data: [
      {
        image: './images/nonePillar.png',
        name: 'None',
        value: 'none',
        lang: {
          en: 'None',
          es: 'Sin postes',
        },
      },
      {
        image: './images/cPillar.png',
        name: 'C Shape',
        value: 'cShape',
        lang: {
          en: 'C Shape',
          es: 'Curvos',
        },
      },
      {
        image: './images/vPillar.png',
        name: 'Z Shape',
        value: 'vShape',
        lang: {
          en: 'Z Shape',
          es: 'Forma Z',
        },
      },
      {
        image: './images/straightPillar.png',
        name: 'Straight',
        value: 'straight',
        lang: {
          en: 'Straight',
          es: 'Rectos',
        },
      },
    ],
  },
  {
    name: 'light post color',
    value: 'lightColor',
    selectionType: 'colorValue',
    title: 'Light Post color',
    lang: {
      en: 'Light Post color',
      es: 'Color de poste de luz',
    },
    data: [
      {
        name: 'White',
        image: '',
        value: '#FFFFFF',
      },
      {
        name: 'Green',
        image: '',
        value: '#7cd359',
        lang: {
          en: 'Green',
          es: 'Verde',
        },
      },
      {
        name: 'Blue',
        image: '',
        value: '#50c9eb',
        lang: {
          en: 'Blue',
          es: 'Azul',
        },
      },
      {
        name: 'Black',
        image: '',
        value: '#0e0e0f',
        lang: {
          en: 'Black',
          es: 'Negro',
        },
      },
      {
        name: 'Yellow',
        image: '',
        value: '#ddea3e',
      },
      {
        name: 'Red',
        image: '',
        value: '#f06363',
      },
      {
        name: 'Gray',
        image: '',
        value: '#d3d3d3',
      },
    ],
  },
  {
    name: "Door's Location",
    value: 'doorLocation',
    selectionType: 'imageOption-3',
    title: "Door's Location options",
    lang: {
      en: 'Door Location',
      es: 'Ubicación de puerta',
    },
    data: [
      {
        image: './images/locationBoth.png',
        name: 'Both',
        value: 'both',
        lang: {
          en: 'Both',
          es: 'Ambos lados',
        },
      },
      {
        image: './images/locationLeft.png',
        name: 'Left',
        value: 'left',
        lang: {
          en: 'Left',
          es: 'Izquierda',
        },
      },
      {
        image: './images/locationRight.png',
        name: 'Right',
        value: 'right',
        lang: {
          en: 'Right',
          es: 'Derecha',
        },
      },
    ],
  },
  {
    name: 'Doors Type',
    value: 'doorType',
    selectionType: 'imageOption-3',
    title: 'Doors Type options',
    lang: {
      en: 'Doors Type',
      es: 'Tipo de puertas',
    },
    data: [
      {
        image: './images/noDoorProtection.png',
        name: 'No Doors With Protections',
        value: '2DoorProtection',
        lang: {
          en: 'No Doors With Protections',
          es: 'Sin puertas + protecciones',
        },
      },
      {
        image: './images/noDoorNonProtection.png',
        name: 'No Doors Without Protections',
        value: '2DoorNonProtection',
        lang: {
          en: 'No Doors Without Protections',
          es: 'Sin puertas ni protecciones',
        },
      },
      {
        image: './images/regularDoor.png',
        name: 'Regular Door',
        value: 'regularDoor',
        lang: {
          en: 'Regular Door',
          es: ' Puertas abatibles',
        },
      },
      // {
      //   image: './images/twoSlidingDoors.png',
      //   name: 'Two Sliding Doors',
      //   value: 'slidingDoor',
      // },
    ],
  },
  {
    name: 'Benches',
    value: 'benches',
    selectionType: 'imageOption-3',
    title: 'Benches',
    lang: {
      en: 'Benches',
      es: 'Bancos',
    },
    data: [
      {
        image: './images/benchesNone.png',
        name: 'None',
        value: 'none',
        lang: {
          en: 'None',
          es: 'Sin banquillos',
        },
      },
      {
        image: './images/benchesLeft.png',
        name: 'Left',
        value: 'left',
        lang: {
          en: 'Left',
          es: 'Izquierda',
        },
      },
      {
        image: './images/benchesRight.png',
        name: 'Right',
        value: 'right',
        lang: {
          en: 'Right',
          es: 'Derecha',
        },
      },
      {
        image: './images/benchesBoth.png',
        name: 'Both',
        value: 'both',
        lang: {
          en: 'Both',
          es: 'Ambos lados',
        },
      },
    ],
  },
  // {
  //   name: 'Personalized Corners',
  //   value: 'personalizedCorners',
  //   selectionType: 'toggle-1',
  //   title: 'Personalized Corners',
  //   data: [
  //     {
  //       image: './images/doorLeft.png',
  //       name: 'Personalized Corners',
  //       value: 1,
  //     },
  //   ],
  // },
  {
    name: 'Personalized Net',
    value: 'personalizedNet',
    selectionType: 'toggle-1',
    title: 'Personalized Net',
    lang: {
      en: 'Personalized Net',
      es: 'Red personalizada',
    },
    data: [
      {
        image: './images/doorLeft.png',
        name: 'Personalized Net',
        lang: {
          en: 'Personalized Net',
          es: 'Red personalizada',
        },
        value: 1,
      },
    ],
  },
  {
    name: 'Protection',
    value: 'protection',
    selectionType: 'multi-dropdown',
    title: 'Protection',
    lang: {
      en: 'Protection',
      es: 'Protecciones',
    },
    data: [
      // {
      //   image: '',
      //   name: 'None',
      //   value: 1,
      // },
      {
        image: '',
        name: 'Right',
        value: 'right',
        lang: {
          en: 'Right',
          es: 'Derecha',
        },
      },
      {
        image: '',
        name: 'Left',
        value: 'left',
        lang: {
          en: 'Left',
          es: 'Izquierda',
        },
      },
      {
        image: '',
        name: 'Back',
        value: 'back',
        lang: {
          en: 'Back',
          es: 'Parte trasera',
        },
      },
      {
        image: '',
        name: 'Front',
        value: 'front',
        lang: {
          en: 'Front',
          es: 'Frontal',
        },
      },
    ],
  },
  // {
  //   name: 'Interior',
  //   value: 'interior',
  //   selectionType: 'toggle-1',
  //   title: 'Interior',
  //   data: [
  //     {
  //       image: './images/doorLeft.png',
  //       name: 'Interior',
  //       value: 1,
  //     },
  //   ],
  // },
  {
    name: 'Roofing',
    value: 'roofing',
    selectionType: 'imageOption-3',
    title: 'Roofing',
    lang: {
      en: 'Roofing',
      es: 'Cubierta',
    },
    data: [
      {
        image: './images/noRoof.png',
        name: 'None',
        value: 'none',
        lang: {
          en: 'None',
          es: 'Ninguna',
        },
      },
      {
        image: './images/roofCover.png',
        name: 'Cover',
        value: 'cover',
        lang: {
          en: 'Cover',
          es: 'Curva',
        },
      },
      {
        image: './images/roofHangar.png',
        name: 'Hangar',
        value: 'hangar',
        lang: {
          en: 'Hangar',
          es: 'A dos aguas',
        },
      },
    ],
  },
];

export const RALColors: { name: string; hexValue: string }[] = [
  { name: 'RAL 1000', hexValue: '#CCC58F' },
  { name: 'RAL 1001', hexValue: '#D1BE89' },
  { name: 'RAL 1002', hexValue: '#D7A84B' },
  { name: 'RAL 1003', hexValue: '#F3A51C' },
  { name: 'RAL 1004', hexValue: '#EFA800' },
  { name: 'RAL 1005', hexValue: '#C68933' },
  { name: 'RAL 1006', hexValue: '#EFAF00' },
  { name: 'RAL 1007', hexValue: '#EBA200' },
  { name: 'RAL 1011', hexValue: '#AF8A54' },
  { name: 'RAL 1012', hexValue: '#D7B52A' },
  { name: 'RAL 1013', hexValue: '#EDE6D6' },
  { name: 'RAL 1014', hexValue: '#EFE2C5' },
  { name: 'RAL 1015', hexValue: '#EBD3A3' },
  { name: 'RAL 1016', hexValue: '#F7E150' },
  { name: 'RAL 1017', hexValue: '#F8B500' },
  { name: 'RAL 1018', hexValue: '#FED300' },
  { name: 'RAL 1019', hexValue: '#9C7D0A' },
  { name: 'RAL 1020', hexValue: '#8A6642' },
  { name: 'RAL 1021', hexValue: '#FFC800' },
  { name: 'RAL 1023', hexValue: '#F5C500' },
  { name: 'RAL 1024', hexValue: '#E3BC00' },
  { name: 'RAL 1026', hexValue: '#FF6600' },
  { name: 'RAL 1027', hexValue: '#C68951' },
  { name: 'RAL 1028', hexValue: '#FED141' },
  { name: 'RAL 1032', hexValue: '#D9A729' },
  { name: 'RAL 1033', hexValue: '#F6A900' },
  { name: 'RAL 1034', hexValue: '#D09200' },
  { name: 'RAL 1035', hexValue: '#866200' },
  { name: 'RAL 1036', hexValue: '#EF8E38' },
  { name: 'RAL 1037', hexValue: '#D28F00' },
  { name: 'RAL 2000', hexValue: '#ED6D3D' },
  { name: 'RAL 2001', hexValue: '#DD5424' },
  { name: 'RAL 2002', hexValue: '#D8602D' },
  { name: 'RAL 2003', hexValue: '#FF5318' },
  { name: 'RAL 2004', hexValue: '#FF2301' },
  { name: 'RAL 2005', hexValue: '#FF2301' },
  { name: 'RAL 2007', hexValue: '#FFA420' },
  { name: 'RAL 2008', hexValue: '#F58C46' },
  { name: 'RAL 2009', hexValue: '#F56C20' },
  { name: 'RAL 2010', hexValue: '#FF4D00' },
  { name: 'RAL 2011', hexValue: '#ED760E' },
  { name: 'RAL 2012', hexValue: '#E85C23' },
  { name: 'RAL 2013', hexValue: '#FF3800' },
  { name: 'RAL 3000', hexValue: '#A6000B' },
  { name: 'RAL 3001', hexValue: '#AF2B1E' },
  { name: 'RAL 3002', hexValue: '#A82224' },
  { name: 'RAL 3003', hexValue: '#9B111E' },
  { name: 'RAL 3004', hexValue: '#75151E' },
  { name: 'RAL 3005', hexValue: '#641220' },
  { name: 'RAL 3007', hexValue: '#412227' },
  { name: 'RAL 3009', hexValue: '#6D3F32' },
  { name: 'RAL 3011', hexValue: '#781F19' },
  { name: 'RAL 3012', hexValue: '#C1876B' },
  { name: 'RAL 3013', hexValue: '#A12312' },
  { name: 'RAL 3014', hexValue: '#D36E70' },
  { name: 'RAL 3015', hexValue: '#E1686A' },
  { name: 'RAL 3016', hexValue: '#B32821' },
  { name: 'RAL 3017', hexValue: '#C92228' },
  { name: 'RAL 3018', hexValue: '#D53E31' },
  { name: 'RAL 3020', hexValue: '#CC0605' },
  { name: 'RAL 3022', hexValue: '#D94972' },
  { name: 'RAL 3024', hexValue: '#F80000' },
  { name: 'RAL 3026', hexValue: '#FF0000' },
  { name: 'RAL 3027', hexValue: '#FF0000' },
  { name: 'RAL 3028', hexValue: '#F40009' },
  { name: 'RAL 3031', hexValue: '#A1230A' },
  { name: 'RAL 3032', hexValue: '#721422' },
  { name: 'RAL 3033', hexValue: '#8E2323' },
  { name: 'RAL 4001', hexValue: '#6D3F5B' },
  { name: 'RAL 4002', hexValue: '#922B3E' },
  { name: 'RAL 4003', hexValue: '#DE4C8A' },
  { name: 'RAL 4004', hexValue: '#641C34' },
  { name: 'RAL 4005', hexValue: '#5D2752' },
  { name: 'RAL 4006', hexValue: '#9A275B' },
  { name: 'RAL 4007', hexValue: '#402A44' },
  { name: 'RAL 4008', hexValue: '#924E7D' },
  { name: 'RAL 4009', hexValue: '#A18594' },
  { name: 'RAL 4010', hexValue: '#CF3476' },
  { name: 'RAL 4011', hexValue: '#4D233D' },
  { name: 'RAL 4012', hexValue: '#6C4675' },
  { name: 'RAL 5000', hexValue: '#004389' },
  { name: 'RAL 5001', hexValue: '#0055A4' },
  { name: 'RAL 5002', hexValue: '#0D2E57' },
  { name: 'RAL 5003', hexValue: '#001C3D' },
  { name: 'RAL 5004', hexValue: '#0D1C2E' },
  { name: 'RAL 5005', hexValue: '#004C87' },
  { name: 'RAL 5007', hexValue: '#00589D' },
  { name: 'RAL 5008', hexValue: '#003B4D' },
  { name: 'RAL 5009', hexValue: '#004C73' },
  { name: 'RAL 5010', hexValue: '#003E6D' },
  { name: 'RAL 5011', hexValue: '#273D52' },
  { name: 'RAL 5012', hexValue: '#0066A2' },
  { name: 'RAL 5013', hexValue: '#0D2945' },
  { name: 'RAL 5014', hexValue: '#4D668C' },
  { name: 'RAL 5015', hexValue: '#004C97' },
  { name: 'RAL 5017', hexValue: '#004B8D' },
  { name: 'RAL 5018', hexValue: '#007CB7' },
  { name: 'RAL 5019', hexValue: '#0B5583' },
  { name: 'RAL 5020', hexValue: '#1C4F66' },
  { name: 'RAL 5021', hexValue: '#006B7E' },
  { name: 'RAL 5022', hexValue: '#004E63' },
  { name: 'RAL 5023', hexValue: '#486591' },
  { name: 'RAL 5024', hexValue: '#27558C' },
  { name: 'RAL 5025', hexValue: '#2A6A8B' },
  { name: 'RAL 5026', hexValue: '#102C54' },
  { name: 'RAL 6000', hexValue: '#316650' },
  { name: 'RAL 6001', hexValue: '#287233' },
  { name: 'RAL 6002', hexValue: '#27682F' },
  { name: 'RAL 6003', hexValue: '#355D37' },
  { name: 'RAL 6004', hexValue: '#08433D' },
  { name: 'RAL 6005', hexValue: '#1E5945' },
  { name: 'RAL 6006', hexValue: '#1C4C3A' },
  { name: 'RAL 6007', hexValue: '#2D3E32' },
  { name: 'RAL 6008', hexValue: '#273631' },
  { name: 'RAL 6009', hexValue: '#213529' },
  { name: 'RAL 6010', hexValue: '#547C2B' },
  { name: 'RAL 6011', hexValue: '#3D642D' },
  { name: 'RAL 6012', hexValue: '#273E26' },
  { name: 'RAL 6013', hexValue: '#6C7156' },
  { name: 'RAL 6014', hexValue: '#47402E' },
  { name: 'RAL 6015', hexValue: '#3B3C36' },
  { name: 'RAL 6016', hexValue: '#006E3A' },
  { name: 'RAL 6017', hexValue: '#1E5945' },
  { name: 'RAL 6018', hexValue: '#57A639' },
  { name: 'RAL 6019', hexValue: '#BDECB6' },
  { name: 'RAL 6020', hexValue: '#2E3A23' },
  { name: 'RAL 6021', hexValue: '#89AC76' },
  { name: 'RAL 6022', hexValue: '#25221B' },
  { name: 'RAL 6024', hexValue: '#308446' },
  { name: 'RAL 6025', hexValue: '#3D642D' },
  { name: 'RAL 6026', hexValue: '#0E4438' },
  { name: 'RAL 6027', hexValue: '#1C542D' },
  { name: 'RAL 6028', hexValue: '#2C5545' },
  { name: 'RAL 6029', hexValue: '#00662F' },
  { name: 'RAL 6032', hexValue: '#317F43' },
  { name: 'RAL 6033', hexValue: '#497E76' },
  { name: 'RAL 6034', hexValue: '#7FB5B5' },
  { name: 'RAL 6035', hexValue: '#008D7D' },
  { name: 'RAL 6036', hexValue: '#005D4E' },
  { name: 'RAL 6037', hexValue: '#26A251' },
  { name: 'RAL 6038', hexValue: '#00BB2D' },
  { name: 'RAL 7000', hexValue: '#78858B' },
  { name: 'RAL 7001', hexValue: '#8A9597' },
  { name: 'RAL 7002', hexValue: '#7E7B52' },
  { name: 'RAL 7003', hexValue: '#6C7059' },
  { name: 'RAL 7004', hexValue: '#969992' },
  { name: 'RAL 7005', hexValue: '#646B63' },
  { name: 'RAL 7006', hexValue: '#756F61' },
  { name: 'RAL 7008', hexValue: '#6A5F31' },
  { name: 'RAL 7009', hexValue: '#4D5645' },
  { name: 'RAL 7010', hexValue: '#4C514A' },
  { name: 'RAL 7011', hexValue: '#434B4D' },
  { name: 'RAL 7012', hexValue: '#4E5754' },
  { name: 'RAL 7013', hexValue: '#464531' },
  { name: 'RAL 7015', hexValue: '#434750' },
  { name: 'RAL 7016', hexValue: '#293133' },
  { name: 'RAL 7021', hexValue: '#23282B' },
  { name: 'RAL 7022', hexValue: '#332F2C' },
  { name: 'RAL 7023', hexValue: '#686C5E' },
  { name: 'RAL 7024', hexValue: '#424445' },
  { name: 'RAL 7026', hexValue: '#2C2C2C' },
  { name: 'RAL 7030', hexValue: '#8B8C7A' },
  { name: 'RAL 7031', hexValue: '#474B4E' },
  { name: 'RAL 7032', hexValue: '#B8B799' },
  { name: 'RAL 7033', hexValue: '#7D8471' },
  { name: 'RAL 7034', hexValue: '#8F8B66' },
  { name: 'RAL 7035', hexValue: '#C5C7C4' },
  { name: 'RAL 7036', hexValue: '#7F7679' },
  { name: 'RAL 7037', hexValue: '#7D7F7D' },
  { name: 'RAL 7038', hexValue: '#B5B8B1' },
  { name: 'RAL 7039', hexValue: '#6C6960' },
  { name: 'RAL 7040', hexValue: '#9DA1AA' },
  { name: 'RAL 7042', hexValue: '#8D948D' },
  { name: 'RAL 7043', hexValue: '#4E5452' },
  { name: 'RAL 7044', hexValue: '#CAC4B0' },
  { name: 'RAL 7045', hexValue: '#909090' },
  { name: 'RAL 7046', hexValue: '#82898F' },
  { name: 'RAL 7047', hexValue: '#D0D0D0' },
  { name: 'RAL 7048', hexValue: '#898176' },
  { name: 'RAL 8000', hexValue: '#826C34' },
  { name: 'RAL 8001', hexValue: '#955F20' },
  { name: 'RAL 8002', hexValue: '#6C3B2A' },
  { name: 'RAL 8003', hexValue: '#734222' },
  { name: 'RAL 8004', hexValue: '#8E402A' },
  { name: 'RAL 8007', hexValue: '#59351F' },
  { name: 'RAL 8008', hexValue: '#6F4F28' },
  { name: 'RAL 8011', hexValue: '#5B3A29' },
  { name: 'RAL 8012', hexValue: '#592321' },
  { name: 'RAL 8014', hexValue: '#382C1E' },
  { name: 'RAL 8015', hexValue: '#633A34' },
  { name: 'RAL 8016', hexValue: '#4C2F27' },
  { name: 'RAL 8017', hexValue: '#45322E' },
  { name: 'RAL 8019', hexValue: '#403A3A' },
  { name: 'RAL 8022', hexValue: '#1F1B19' },
  { name: 'RAL 8023', hexValue: '#A65E2E' },
  { name: 'RAL 8024', hexValue: '#79553D' },
  { name: 'RAL 8025', hexValue: '#755C48' },
  { name: 'RAL 8028', hexValue: '#4C2C1D' },
  { name: 'RAL 8029', hexValue: '#763C28' },
  { name: 'RAL 9001', hexValue: '#FDF4E3' },
  { name: 'RAL 9002', hexValue: '#E7EBDA' },
  { name: 'RAL 9003', hexValue: '#F4F4F4' },
  { name: 'RAL 9004', hexValue: '#282828' },
  { name: 'RAL 9005', hexValue: '#0A0A0A' },
  { name: 'RAL 9010', hexValue: '#F4F4F4' },
  { name: 'RAL 9011', hexValue: '#1C1C1C' },
  { name: 'RAL 9016', hexValue: '#F6F6F6' },
  { name: 'RAL 9017', hexValue: '#1E1E1E' },
  { name: 'RAL 9018', hexValue: '#D7D7D7' },
];

export const countries = [
  { name: 'Afghanistan', id: 1 },
  { name: 'Albania', id: 2 },
  { name: 'Algeria', id: 3 },
  { name: 'Andorra', id: 4 },
  { name: 'Angola', id: 5 },
  { name: 'Antigua and Barbuda', id: 6 },
  { name: 'Argentina', id: 7 },
  { name: 'Armenia', id: 8 },
  { name: 'Australia', id: 9 },
  { name: 'Austria', id: 10 },
  { name: 'Azerbaijan', id: 11 },
  { name: 'Bahamas', id: 12 },
  { name: 'Bahrain', id: 13 },
  { name: 'Bangladesh', id: 14 },
  { name: 'Barbados', id: 15 },
  { name: 'Belarus', id: 16 },
  { name: 'Belgium', id: 17 },
  { name: 'Belize', id: 18 },
  { name: 'Benin', id: 19 },
  { name: 'Bhutan', id: 20 },
  { name: 'Bolivia', id: 21 },
  { name: 'Bosnia and Herzegovina', id: 22 },
  { name: 'Botswana', id: 23 },
  { name: 'Brazil', id: 24 },
  { name: 'Brunei', id: 25 },
  { name: 'Bulgaria', id: 26 },
  { name: 'Burkina Faso', id: 27 },
  { name: 'Burundi', id: 28 },
  { name: 'Cabo Verde', id: 29 },
  { name: 'Cambodia', id: 30 },
  { name: 'Cameroon', id: 31 },
  { name: 'Canada', id: 32 },
  { name: 'Central African Republic', id: 33 },
  { name: 'Chad', id: 34 },
  { name: 'Chile', id: 35 },
  { name: 'China', id: 36 },
  { name: 'Colombia', id: 37 },
  { name: 'Comoros', id: 38 },
  { name: 'Congo', id: 39 },
  { name: 'Costa Rica', id: 40 },
  { name: 'Croatia', id: 41 },
  { name: 'Cuba', id: 42 },
  { name: 'Cyprus', id: 43 },
  { name: 'Czech Republic', id: 44 },
  { name: 'Denmark', id: 45 },
  { name: 'Djibouti', id: 46 },
  { name: 'Dominica', id: 47 },
  { name: 'Dominican Republic', id: 48 },
  { name: 'East Timor', id: 49 },
  { name: 'Ecuador', id: 50 },
  { name: 'Egypt', id: 51 },
  { name: 'El Salvador', id: 52 },
  { name: 'Equatorial Guinea', id: 53 },
  { name: 'Eritrea', id: 54 },
  { name: 'Estonia', id: 55 },
  { name: 'Eswatini', id: 56 },
  { name: 'Ethiopia', id: 57 },
  { name: 'Fiji', id: 58 },
  { name: 'Finland', id: 59 },
  { name: 'France', id: 60 },
  { name: 'Gabon', id: 61 },
  { name: 'Gambia', id: 62 },
  { name: 'Georgia', id: 63 },
  { name: 'Germany', id: 64 },
  { name: 'Ghana', id: 65 },
  { name: 'Greece', id: 66 },
  { name: 'Grenada', id: 67 },
  { name: 'Guatemala', id: 68 },
  { name: 'Guinea', id: 69 },
  { name: 'Guinea-Bissau', id: 70 },
  { name: 'Guyana', id: 71 },
  { name: 'Haiti', id: 72 },
  { name: 'Honduras', id: 73 },
  { name: 'Hungary', id: 74 },
  { name: 'Iceland', id: 75 },
  { name: 'India', id: 76 },
  { name: 'Indonesia', id: 77 },
  { name: 'Iran', id: 78 },
  { name: 'Iraq', id: 79 },
  { name: 'Ireland', id: 80 },
  { name: 'Israel', id: 81 },
  { name: 'Italy', id: 82 },
  { name: 'Jamaica', id: 83 },
  { name: 'Japan', id: 84 },
  { name: 'Jordan', id: 85 },
  { name: 'Kazakhstan', id: 86 },
  { name: 'Kenya', id: 87 },
  { name: 'Kiribati', id: 88 },
  { name: 'Korea, North', id: 89 },
  { name: 'Korea, South', id: 90 },
  { name: 'Kosovo', id: 91 },
  { name: 'Kuwait', id: 92 },
  { name: 'Kyrgyzstan', id: 93 },
  { name: 'Laos', id: 94 },
  { name: 'Latvia', id: 95 },
  { name: 'Lebanon', id: 96 },
  { name: 'Lesotho', id: 97 },
  { name: 'Liberia', id: 98 },
  { name: 'Libya', id: 99 },
  { name: 'Liechtenstein', id: 100 },
  { name: 'Lithuania', id: 101 },
  { name: 'Luxembourg', id: 102 },
  { name: 'Madagascar', id: 103 },
  { name: 'Malawi', id: 104 },
  { name: 'Malaysia', id: 105 },
  { name: 'Maldives', id: 106 },
  { name: 'Mali', id: 107 },
  { name: 'Malta', id: 108 },
  { name: 'Marshall Islands', id: 109 },
  { name: 'Mauritania', id: 110 },
  { name: 'Mauritius', id: 111 },
  { name: 'Mexico', id: 112 },
  { name: 'Micronesia', id: 113 },
  { name: 'Moldova', id: 114 },
  { name: 'Monaco', id: 115 },
  { name: 'Mongolia', id: 116 },
  { name: 'Montenegro', id: 117 },
  { name: 'Morocco', id: 118 },
  { name: 'Mozambique', id: 119 },
  { name: 'Myanmar', id: 120 },
  { name: 'Namibia', id: 121 },
  { name: 'Nauru', id: 122 },
  { name: 'Nepal', id: 123 },
  { name: 'Netherlands', id: 124 },
  { name: 'New Zealand', id: 125 },
  { name: 'Nicaragua', id: 126 },
  { name: 'Niger', id: 127 },
  { name: 'Nigeria', id: 128 },
  { name: 'North Macedonia', id: 129 },
  { name: 'Norway', id: 130 },
  { name: 'Oman', id: 131 },
  { name: 'Pakistan', id: 132 },
  { name: 'Palau', id: 133 },
  { name: 'Panama', id: 134 },
  { name: 'Papua New Guinea', id: 135 },
  { name: 'Paraguay', id: 136 },
  { name: 'Peru', id: 137 },
  { name: 'Philippines', id: 138 },
  { name: 'Poland', id: 139 },
  { name: 'Portugal', id: 140 },
  { name: 'Qatar', id: 141 },
  { name: 'Romania', id: 142 },
  { name: 'Russia', id: 143 },
  { name: 'Rwanda', id: 144 },
  { name: 'Saint Kitts and Nevis', id: 145 },
  { name: 'Saint Lucia', id: 146 },
  { name: 'Saint Vincent and the Grenadines', id: 147 },
  { name: 'Samoa', id: 148 },
  { name: 'San Marino', id: 149 },
  { name: 'Sao Tome and Principe', id: 150 },
  { name: 'Saudi Arabia', id: 151 },
  { name: 'Senegal', id: 152 },
  { name: 'Serbia', id: 153 },
  { name: 'Seychelles', id: 154 },
  { name: 'Sierra Leone', id: 155 },
  { name: 'Singapore', id: 156 },
  { name: 'Slovakia', id: 157 },
  { name: 'Slovenia', id: 158 },
  { name: 'Solomon Islands', id: 159 },
  { name: 'Somalia', id: 160 },
  { name: 'South Africa', id: 161 },
  { name: 'South Sudan', id: 162 },
  { name: 'Spain', id: 163 },
  { name: 'Sri Lanka', id: 164 },
  { name: 'Sudan', id: 165 },
  { name: 'Suriname', id: 166 },
  { name: 'Sweden', id: 167 },
  { name: 'Switzerland', id: 168 },
  { name: 'Syria', id: 169 },
  { name: 'Taiwan', id: 170 },
  { name: 'Tajikistan', id: 171 },
  { name: 'Tanzania', id: 172 },
  { name: 'Thailand', id: 173 },
  { name: 'Togo', id: 174 },
  { name: 'Tonga', id: 175 },
  { name: 'Trinidad and Tobago', id: 176 },
  { name: 'Tunisia', id: 177 },
  { name: 'Turkey', id: 178 },
  { name: 'Turkmenistan', id: 179 },
  { name: 'Tuvalu', id: 180 },
  { name: 'Uganda', id: 181 },
  { name: 'Ukraine', id: 182 },
  { name: 'United Arab Emirates', id: 183 },
  { name: 'United Kingdom', id: 184 },
  { name: 'United States', id: 185 },
  { name: 'Uruguay', id: 186 },
  { name: 'Uzbekistan', id: 187 },
  { name: 'Vanuatu', id: 188 },
  { name: 'Vatican City', id: 189 },
  { name: 'Venezuela', id: 190 },
  { name: 'Vietnam', id: 191 },
  { name: 'Yemen', id: 192 },
  { name: 'Zambia', id: 193 },
  { name: 'Zimbabwe', id: 194 },
];

export const states = [
  { name: 'Alabama', id: 1 },
  { name: 'Alaska', id: 2 },
  { name: 'Arizona', id: 3 },
  { name: 'Arkansas', id: 4 },
  { name: 'California', id: 5 },
  { name: 'Colorado', id: 6 },
  { name: 'Connecticut', id: 7 },
  { name: 'Delaware', id: 8 },
  { name: 'Florida', id: 9 },
  { name: 'Georgia', id: 10 },
  { name: 'Hawaii', id: 11 },
  { name: 'Idaho', id: 12 },
  { name: 'Illinois', id: 13 },
  { name: 'Indiana', id: 14 },
  { name: 'Iowa', id: 15 },
  { name: 'Kansas', id: 16 },
  { name: 'Kentucky', id: 17 },
  { name: 'Louisiana', id: 18 },
  { name: 'Maine', id: 19 },
  { name: 'Maryland', id: 20 },
  { name: 'Massachusetts', id: 21 },
  { name: 'Michigan', id: 22 },
  { name: 'Minnesota', id: 23 },
  { name: 'Mississippi', id: 24 },
  { name: 'Missouri', id: 25 },
  { name: 'Montana', id: 26 },
  { name: 'Nebraska', id: 27 },
  { name: 'Nevada', id: 28 },
  { name: 'New Hampshire', id: 29 },
  { name: 'New Jersey', id: 30 },
  { name: 'New Mexico', id: 31 },
  { name: 'New York', id: 32 },
  { name: 'North Carolina', id: 33 },
  { name: 'North Dakota', id: 34 },
  { name: 'Ohio', id: 35 },
  { name: 'Oklahoma', id: 36 },
  { name: 'Oregon', id: 37 },
  { name: 'Pennsylvania', id: 38 },
  { name: 'Rhode Island', id: 39 },
  { name: 'South Carolina', id: 40 },
  { name: 'South Dakota', id: 41 },
  { name: 'Tennessee', id: 42 },
  { name: 'Texas', id: 43 },
  { name: 'Utah', id: 44 },
  { name: 'Vermont', id: 45 },
  { name: 'Virginia', id: 46 },
  { name: 'Washington', id: 47 },
  { name: 'West Virginia', id: 48 },
  { name: 'Wisconsin', id: 49 },
  { name: 'Wyoming', id: 50 },
];

// Previous: Anterior
// Next: Siguiente

// Tipo de césped
// Fibrilated: Fibrilado
// Monofilament: Monofilamento
// Texturised: Texturizado

// Colores:
// Blue: Azul
// Green: Verde
// Orange: Naranja
// Purple: Morado
// Black: Negro
// Pink : Rosa

// Tipo de postes de luz
// C Shape: Curvos
// None: Sin postes
// Z Shape: Forma Z
// Straight: Rectos

// Ubicación de Puerta
// Both: Ambos lados
// Left: Izquierda
// Right: Derecha

// Tipo de puertas:
// No doors with protections: Sin puertas + protecciones
// No doors no protections: Sin puertas ni protecciones
// Regular door: Puertas abatibles
// Bancos
// None: Sin banquillos
// Left: Izquierda
// Right: Derecha
// Both: Ambos lados

// Personalized net: Red personalizada

// Protecciones:
// Left: Izquierda
// Right: Derecha
// Back: Parte trasera
// Frontal: Frontal

// Cubierta
// None: Ninguna
// Cover: Curva
// Hangar: A dos aguas

// Send Project: Descargar projecto
